import { DirectiveBinding, ObjectDirective } from 'vue'

function setFontSize(el: HTMLElement, binding: DirectiveBinding) {
	// 首先检查修饰符
	const modifiers = Object.keys(binding.modifiers)
	const sizeModifiers = ['xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl', 'xxxl']

	// 如果有修饰符，优先使用修饰符
	if (modifiers.length > 0) {
		for (const modifier of modifiers) {
			if (sizeModifiers.includes(modifier)) {
				el.classList.add(`to-size-${modifier}`)
				return
			}
		}
	}

	// 如果没有修饰符，则使用value
	const val = binding.value
	if (val) {
		if (sizeModifiers.includes(val)) {
			el.classList.add(`to-size-${val}`)
		} else if (!isNaN(Number(val))) {
			el.style.fontSize = `${val * 100}%`
		} else {
			el.style.fontSize = val
		}
	}
}

const vSizeDirective: ObjectDirective = {
	mounted(el, binding) {
		setFontSize(el, binding)
	},
	updated(el, binding) {
		setFontSize(el, binding)
	},
}

export default vSizeDirective
